import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from '../models/menu';
import { SidebarComponent } from '../shared/sidebar/sidebar.component';
import { GoogleAuthenticationService } from '../core/login/google-authentication.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnDestroy {

  @ViewChild('sidebar') sidebar: SidebarComponent;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private googleAuthenticationService: GoogleAuthenticationService
  ) {}

  ngOnInit(): void {
    const url = this.router.url;
    const isLoginOrEmpty = url === '/login' || url === '/' || url === '';
    if (isLoginOrEmpty) {
      this.googleAuthenticationService.isLoggedIn$
        .pipe(takeUntil(this.destroy$))
        .subscribe(isLoggedIn => {
          if (isLoggedIn) {
            this.router.navigate(['/pages/dashboard']);
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeMenuOption(event: boolean){

    if(event){
      this.sidebar.cleanMenuOptionsStyle();

      const options: Menu[] = this.sidebar.optionsMenu;

      const optionNumber = this.getOption(options, "Estado de Solicitudes");

      this.sidebar.setOptionSelectedStyle(optionNumber);
    }

  }

  getOption(options: Menu[], option: string){
    for(let i = 0; i < options.length; i++){
      if(options[i].opcion === option){
        return i;
      }
    }

    return -1;
  }
}
